import { SampleComponent } from "../components/Sample";

export const Sample = () => {
  return (
    <div>
      <SampleComponent />
    </div>
  );
};
